import { BlockedEmailClient } from 'api/api';
import { Action, Dispatch } from 'redux';
import { notificationService } from 'services/notification-service';
import { localizedDynamic } from 'state/i18n';
import { AsyncOperationBuilder, handleApiError } from 'utilities/api-helper';
import { blockedEmailClient } from '../api-clients';
import { getBlockedEmailsAction, unblockEmailAction } from './actions';

export function getBlockedEmails() {
	return AsyncOperationBuilder(
		getBlockedEmailsAction,
		apiClient => (apiClient as BlockedEmailClient).getBlocked(),
		undefined,
		blockedEmailClient
	);
}

export function unblockEmail(email: string) {
	return async (dispatch: Dispatch<Action<any>>) => {
		dispatch(unblockEmailAction.started(email));

		try {
			await blockedEmailClient.unblock(email);
			notificationService.showSuccessMessage(localizedDynamic('blockedEmails.unblockSuccess'));
			dispatch(unblockEmailAction.done({ params: email, result: undefined } as any));

			await getBlockedEmails()(dispatch);
		} catch (error: any) {
			handleApiError(error);

			dispatch(
				unblockEmailAction.failed({
					params: email,
					error: { code: error?.status ?? 0, message: error?.toString?.() ?? 'Unknown error' },
				} as any)
			);
		}
	};
}
